export class ProductImageDto {
  id?: string;
  type: string;
  size: string;
  url: string;

  image?: string; // deprecated
  imageSize?: string; // deprecated
  imageUrl?: string; // deprecated

  constructor(d?: ProductImageDto) {
    Object.assign(this, d || {});
  }
}
